<mat-form-field>
    <input matInput [(ngModel)]="data.searchedValue" placeholder="search..."
    (keyup.enter)="dialogRef.close(data.searchedValue)"
    >
</mat-form-field>
